import { converters as tableConverters } from 'store/table';
import { IPrompt } from 'types/income';
import { loaders } from './prompts.loaders';
import { Prompt } from './prompts.types';

export const convertPrompt = (prompt: IPrompt): Prompt => {
  return {
    id: prompt.id,
    name: prompt.name,
    prompt: prompt.prompt,
    createdAt: prompt.creationDate,
  };
};

const convertPrompts = (prompts: IPrompt[]): Prompt[] => {
  return prompts.map(convertPrompt);
};

export const converters = {
  getPrompts: ({ data }: Awaited<ReturnType<typeof loaders.getPrompts>>) => {
    const { total, page, pageSize, pages } = tableConverters.getTableData(data);

    return {
      items: convertPrompts(data.data),
      total,
      page,
      pageSize,
      pages,
    };
  },
};
